import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import CtaButton from 'Pods/Shared/CtaButton/CtaButton'
import i18n from 'Pods/Shared/I18n'

function Hire3dFreelancerBanner({locale = 'en'}) {
  const title = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.title', { ns: 'rails', lng: locale })
  const description1 = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.description',
    { ns: 'rails', lng: locale })
  const description2 = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.description2',
    { ns: 'rails', lng: locale })
  const learnMoreButtonText = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.learnMoreButtonText',
    { ns: 'rails', lng: locale })
  const postAProjectButtonText = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.postAProjectButtonText',
    { ns: 'rails', lng: locale })
  const learnMoreButtonUrl = i18n.t('listingPage.footerBanners.hire3dFreelancerBanner.learnMoreButtonUrl',
    { ns: 'rails', lng: locale })

  return (
    <div className="
    footer-banners__freelancer-item
    hide-3d-freelancer-banner
    cgt-card
    cgt-card--inner-space
    is-rounded cgt-card--border"
    >
      <div className="hide-3d-freelancer-banner__container">
        <div className="hide-3d-freelancer-banner__text">
          <span className="cgt-legacy-heading-h4 hide-3d-freelancer-banner__title">
            {title}
          </span>
          <span className="hide-3d-freelancer-banner__description">
            {description1}
          </span>
          <span className="hide-3d-freelancer-banner__description">
            {description2}
          </span>
        </div>
        <div className="hide-3d-freelancer-banner__button-group">
          <Button
            type="secondary"
            customClass="hide-3d-freelancer-banner__button"
            href={learnMoreButtonUrl}
          >
            {learnMoreButtonText}
          </Button>
          <CtaButton
            text={postAProjectButtonText}
            trackText="Post project"
            href="/3d-modeling-jobs/new?meta_source=top_navigation"
            className="hide-3d-freelancer-banner__button"
            buttonSize="medium"
          />
        </div>
      </div>
    </div>
  )
}

Hire3dFreelancerBanner.propTypes = {
  locale: string,
}

export default Hire3dFreelancerBanner
